<div id="overlayId" class="listOfFilters" (click)="setOverlayPanel($event)">
  @for (filter of translatedFilters; track filter; let i = $index) {
    <div>
      @if (i <= 1) {
        <div [ngClass]="{ 'd-flex justify-content-between align-items-center': i === 0 }">
          <span>
            <b>{{ filter.labelToTranslate | translate }}</b> {{ filter.isLabel | translate }}
            <i>« {{ filter.endLabelItalic }} »</i>
          </span>
          @if (i === 0) {
            <i class="bi bi-x-circle reinitButton" [pTooltip]="'advancedSearch.reset' | translate" (click)="reset($event)"></i>
          }
        </div>
      }
    </div>
  }
  @if (translatedFilters.length > 2) {
    <div class="lightBlueColor cursor--pointer setTooltipOnHover">
      {{ 'advancedSearch.xOtherFilters' | translate: { amountSelected: translatedFilters.length - 2 } }}
    </div>
  }
</div>

<p-overlayPanel #overlayButtonDisplayFilters>
  <ng-template pTemplate>
    @for (filter of translatedFilters; track filter; let i = $index) {
      <div id="testOverlayDisplayFilers">
        <div>
          <b>{{ filter.labelToTranslate | translate }}</b> {{ filter.isLabel | translate }}
          <i>« {{ filter.endLabelItalic }} »</i>
        </div>
      </div>
    }
  </ng-template>
</p-overlayPanel>
